// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Button from 'ant-design-vue/lib/button'
import Antd from 'ant-design-vue'
import fastClick from 'fastclick'
import 'ant-design-vue/dist/antd.css'
import $ from 'jquery'
import Swiper from 'swiper'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import 'swiper/js/swiper.min.js'
import 'lib-flexible'
import IScrollView from 'vue-iscroll-view'
import IScroll from 'iscroll'
// 引用fullpage 插件
import 'fullpage.js/vendors/scrolloverflow';
import VueFullPage from 'vue-fullpage.js';
// 引用swetalert 插件
import swal from 'sweetalert';
import axios from 'axios';
Vue.prototype.$axios = axios;
import Api from './api/api.js';

import  './assets/css/resetui.less'
Vue.prototype.$api = Api;
Vue.use(IScrollView, IScroll);
Vue.use(VueFullPage);


Vue.component(Button.name, Button);
Vue.config.productionTip = false
Vue.use(Antd);
Vue.use(VueAwesomeSwiper, /* { default global options } */)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js